<template>
  <div class="section">
    <div class="section-title">
      Join a Game
    </div>
    <div class="section-body">
      <div class="error-text" v-show="joinGameErrorMsg.length > 0">
        {{ joinGameErrorMsg }}
      </div>
      <div class="section-row">
        <input
          class="roomcode-input"
          v-model="joinGameRoomcode"
          type="text"
          placeholder="Enter a room code"
          autocomplete="off"
          autocorrect="off"
          autofocus
          spellcheck="false"
          @keydown.enter.prevent="joinGame"
        >
        <SpinnerButton
          class="button"
          :isProcessing="joinGameButtonClicked"
          @click="joinGame"
        >
          Join
        </SpinnerButton>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import SpinnerButton from '@/components/utilComponents/SpinnerButton';

export default Vue.extend({
  name: 'JoinTeamComponent',
  components: {
    SpinnerButton
  },
  data: () => ({
    joinGameRoomcode: '',
    isJoinGameFormValid: false,
    joinGameButtonClicked: false,
    joinGameErrorMsg: ''
  }),
  computed: {
    auth0UserId: function () {
      return this.$auth.user.sub.replace(/\|/g, '_');
    },
    idToken: function () {
      return this.$auth.idToken;
    }
  },
  methods: {
    async joinGame() {
      try {
        this.joinGameButtonClicked = true;

        const response = await this.axios.post(`${ process.env.VUE_APP_BACKEND_API_URL }/joingamedryrun`, {
          auth0UserId: this.auth0UserId,
          gameRoomcode: this.joinGameRoomcode
        }, {
          headers: {
            'Content-Type': 'application/json', 
            'Authorization': `Bearer ${this.idToken}`
          }
        });

        if ('errorMsg' in response.data) {
          this.joinGameButtonClicked = false;
          this.joinGameErrorMsg = response.data.errorMsg;
        } else {
          this.$router.push({
            name: 'gamesetup',
            params: {
              joinGameRoomcode: this.joinGameRoomcode,
              wasRedirectedFromGameEntrance: true
            }
          });
        }
      } catch (error) {
        console.log('Error:', error);
        this.joinGameButtonClicked = false;
      }
    }
  }
})
</script>

<style scoped lang="scss">
.roomcode-input {
  flex: 1;
  font-size: 1em;
  padding: 0.4em 0.8em;
  margin-right: 0.8em;
  font-family: inherit;
}

.button {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 2.2em;
  width: 6em;
  color: $natural-white;
  background-color: $brand-teal;
  text-align: center;
  border-radius: 0.2em;
  box-shadow: 0 1px 1px 1px $light-gray;
  user-select: none;
  cursor: pointer;
}

.button:hover {
  background-color: $light-teal;
}

.button-content {
  flex: 1;
}

.error-text {
  flex: 1;
  padding: 0.8em 1.2em;
  margin-bottom: 0.6em;
  background-color: $baby-blue;
  border-radius: 0.3em;
}
</style>
